// Reusable privacy information block for forms - displays LGPD/privacy policy information
export function PrivacyInfoBlock() {
  return (
    <div className="mt-8 rounded-2xl border border-slate-200 bg-slate-50 p-6">
      <p className="text-xs leading-relaxed text-slate-700">
        O responsável pelo tratamento dos seus dados pessoais é a Sistech Sistemas. Estes dados serão utilizados para lhe enviar emails informativos sobre os nossos processos e serviços, além de utilizarmos para efeitos estatísticos. Para mais informações sobre como utilizaremos os dados, por favor consulte a nossa Política de Privacidade. Ao utilizar este formulário você concorda com a nossa Política. Para exercer os seus direitos de usuário para retificação ou remoção dos dados sensíveis, contate-nos através do e-mail sistech@sistech.com.br .
      </p>
    </div>
  );
}
